import { render, staticRenderFns } from "./PageEventLevelYoutube.vue?vue&type=template&id=081218fd&scoped=true&"
import script from "./PageEventLevelYoutube.vue?vue&type=script&lang=js&"
export * from "./PageEventLevelYoutube.vue?vue&type=script&lang=js&"
import style0 from "./PageEventLevelYoutube.vue?vue&type=style&index=0&id=081218fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081218fd",
  null
  
)

export default component.exports